import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Attendee } from '../types';
//
// Участник выбранный для просмотра
//
export type AttendeeState = Attendee | null;
const initialState = null as AttendeeState; 

export const attendeeSlice = createSlice({
    name: 'attendee',
    initialState,
    reducers: {
        attendeeSet: (state, action: PayloadAction<AttendeeState>) => {
            return action.payload;
        },
    }
});

export const { attendeeSet } = attendeeSlice.actions;
export default attendeeSlice.reducer;
